import ip from 'icepick';
import { UPDATE_WALLET_PAYMENT_DATA } from './type';

const initialState = ip.freeze({
  walletPaymentData: {
    promo: null,
  },
});

export function walletReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_WALLET_PAYMENT_DATA: {
      state = ip.setIn(state, ['walletPaymentData', 'promo'], action.payload);
      return state;
    }
    default:
      return state;
  }
}
